'use client';

import QuarkLogo from '@/assets/logos/quark/dark-h.svg';
import { Close } from '@mui/icons-material';
import { AppBar, Box, Toolbar } from '@mui/material';
import { AppShellTriggerIcon } from '@prismo-io/design-system';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { SidebarAppetenceList } from './appetence-list';
import { SidebarExperienceList } from './experience-list';
import { SidebarFormationList } from './formation-list';
import { SidebarSkillList } from './skill-list';

type Props = {};

export const Sidebar = (props: Props) => {
  const [activeStep, setActiveStep] = useState<number>(0);
  const pathname = usePathname();

  useEffect(() => {
    setActiveStep(STEPS.findIndex(({ path }) => pathname.endsWith(path)));
  }, [pathname]);

  const STEPS = [
    {
      labelSidebar: 'Experiences',
      path: '/experiences',
    },
    {
      labelSidebar: 'Formations',
      path: '/formations',
    },
    {
      labelSidebar: 'Competences',
      path: '/competences',
    },
    {
      labelSidebar: 'Appetences',
      path: '/appetences',
    },
  ];

  return (
    <>
      <AppBar
        position="static"
        color="transparent"
        variant="outlined"
        elevation={0}
        sx={{ border: 'none' }}
      >
        <Toolbar variant="dense">
          <Image src={QuarkLogo} alt="Logo de Quark" height={32} />
          <Box component="div" flexGrow={1} />
          {/* <ReadingKeyModal isDefaultOpen isQuestionBtn>
            <TipModalContent />
          </ReadingKeyModal> */}
          <AppShellTriggerIcon sx={{ display: { node: 'block', md: 'none' } }}>
            <Close />
          </AppShellTriggerIcon>
        </Toolbar>
      </AppBar>
      <Box component="div" paddingY={2}>
        {pathname.endsWith('/experiences') && <SidebarExperienceList />}
        {pathname.endsWith('/formations') && <SidebarFormationList />}
        {pathname.endsWith('/competences') && <SidebarSkillList />}
        {pathname.endsWith('/appetences') && <SidebarAppetenceList />}
      </Box>
    </>
  );
};
